import type { ReactNode } from 'react'
import { cn } from '@/core/utils/common'

type EmptyStateProps = {
  title: string
  description?: string
  icon?: ReactNode
  action?: ReactNode
  compact?: boolean
}

/** 목록과 시트에서 쓰는 빈 상태. 실제 행동으로 이어지는 링크나 버튼은 action으로 받는다. */
export default function EmptyState({
  title,
  description,
  icon,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center px-4 text-center',
        compact ? 'py-8' : 'py-16'
      )}
    >
      {icon && (
        <span aria-hidden="true" className="mb-3 text-point/65 [&>svg]:size-6">
          {icon}
        </span>
      )}
      <p className="text-c17 leading-[1.4] font-bold tracking-[-0.02em] text-t1 over10:text-c18">
        {title}
      </p>
      {description && (
        <p className="mt-1.5 max-w-sm text-c13 leading-[1.6] text-t3 over10:text-c14">
          {description}
        </p>
      )}
      {action && <div className="mt-4 text-c14 font-semibold">{action}</div>}
    </div>
  )
}
